import axios from "axios";

const BACKEND_URL = 'https://education.mowanzi.com';
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("ga_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Soft handle, page-level can react
    }
    return Promise.reject(err);
  }
);

export default client;
